import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";

import PageTitle from "../../layouts/PageTitle";
import {
  getPermissionByRoleId,
  getRoles,
  createPermissionRoles,
} from "../../../services/academicService";

const theadData = [
  { heading: "Menu", sortingVale: "menu" },
  { heading: "All", sortingVale: "all" },
  { heading: "View", sortingVale: "view" },
  { heading: "Create", sortingVale: "create" },
  { heading: "Delete", sortingVale: "delete" },
  { heading: "Edit", sortingVale: "edit" },
  { heading: "Cancel", sortingVale: "cancel" },
  { heading: "Print", sortingVale: "print" },
];

const roleThead = [{ heading: "Role", sortingVale: "name" }];

const Permissions = () => {
  const [roles, setRoles] = useState([]);
  const [allRoles, setAllRoles] = useState([]); // original full list
  const [selectedRoleId, setSelectedRoleId] = useState(null);
  const [permissionIconData, setPermissionIconData] = useState({
    complete: false,
    ind: Number,
  });
  const [roleIconData, setRoleIconData] = useState({
    complete: false,
    ind: Number,
  });

  const [feeData, setFeeDate] = useState([]);
  const [permissionsLoading, setPermissionsLoading] = useState(false);

  function SotingData(name) {
    const sortedPeople = [...feeData];
    switch (name) {
      case "sno":
        sortedPeople.sort((a, b) => {
          return a.sno < b.sno ? -1 : 1;
        });
        break;
      case "title":
        sortedPeople.sort((a, b) => {
          return permissionIconData.complete
            ? a.title.localeCompare(b.title)
            : b.title.localeCompare(a.title);
        });
        break;
      case "subject":
        sortedPeople.sort((a, b) => {
          return permissionIconData.complete
            ? a.subject.localeCompare(b.subject)
            : b.subject.localeCompare(a.subject);
        });
        break;
      case "department":
        sortedPeople.sort((a, b) => {
          return permissionIconData.complete
            ? a.department.localeCompare(b.department)
            : b.department.localeCompare(a.department);
        });
        break;
      case "type":
        sortedPeople.sort((a, b) => {
          return permissionIconData.complete
            ? a.type.localeCompare(b.type)
            : b.type.localeCompare(a.type);
        });
        break;
      case "cap":
        sortedPeople.sort((a, b) => {
          return permissionIconData.complete
            ? a.cap.localeCompare(b.cap)
            : b.cap.localeCompare(a.cap);
        });
        break;
      case "status":
        sortedPeople.sort((a, b) => {
          return permissionIconData.complete
            ? a.status.localeCompare(b.status)
            : b.status.localeCompare(a.status);
        });
        break;
      default:
        break;
    }
    setFeeDate(sortedPeople);
  }

  function DataSearch(e) {
    const updatesDate = feeData.filter((item) => {
      let selectdata =
        `${item.hod} ${item.type} ${item.department} ${item.subject} ${item.cap} ${item.status}`.toLowerCase();
      return selectdata.includes(e.target.value.toLowerCase());
    });
    setFeeDate([...updatesDate]);
  }

  // role table

  function SotingDataRole(name) {
    const sortedPeople = [...roles];
    switch (name) {
      case "sno":
        sortedPeople.sort((a, b) => {
          return a.sno < b.sno ? -1 : 1;
        });
        break;
      case "name":
        sortedPeople.sort((a, b) => {
          return roleIconData.complete
            ? a.name.localeCompare(b.name)
            : b.name.localeCompare(a.name);
        });
        break;
      case "status":
        sortedPeople.sort((a, b) => {
          return roleIconData.complete
            ? a.status.localeCompare(b.status)
            : b.status.localeCompare(a.status);
        });
        break;

      default:
        break;
    }
    setRoles(sortedPeople);
  }

  function DataSearchRole(e) {
    const updatesDate = allRoles.filter((item) => {
      let selectdata = `${item.name}  ${item.status}`.toLowerCase();
      return selectdata.includes(e.target.value.toLowerCase());
    });
    setRoles([...updatesDate]);
  }

  useEffect(() => {
    fetchRoles();
  }, []);

  useEffect(() => {
    if (selectedRoleId) {
      fetchPermissionsByRoleId();
    }
  }, [selectedRoleId]);

  async function fetchRoles() {
    try {
      const res = await getRoles();
      setRoles(res);
      setAllRoles(res);
      if (res?.length) {
        setSelectedRoleId(res[0].id);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  }

  async function fetchPermissionsByRoleId() {
    setPermissionsLoading(true);
    try {
      const res = await getPermissionByRoleId(selectedRoleId);
      const normalized = Array.isArray(res) ? res : res ? [res] : [];
      setFeeDate(normalized);
    } catch (error) {
      console.error("Error fetching permissions:", error);
      setFeeDate([]);
    } finally {
      setPermissionsLoading(false);
    }
  }

  const PERM_KEYS = ["view", "create", "edit", "delete", "cancel", "print"];

  async function handleCheckbox(rowId, field, value) {
    setFeeDate((prev) =>
      prev.map((row) => {
        if (row.id !== rowId) return row;
        let updated;
        if (field === "all") {
          updated = {
            ...row,
            view: value,
            create: value,
            edit: value,
            delete: value,
            cancel: value,
            print: value,
          };
        } else {
          updated = { ...row, [field]: value };
        }
        const payload = [
          {
            id: updated.id,
            view: updated.view,
            create: updated.create,
            edit: updated.edit,
            delete: updated.delete,
            cancel: updated.cancel,
            print: updated.print,
          },
        ];
        createPermissionRoles(payload).catch((e) =>
          console.error("Save permission failed:", e),
        );
        return updated;
      }),
    );
  }

  return (
    <>
      <PageTitle activeMenu={"All Permissions"} motherMenu={"Security"} />
      <Row>
        <Col lg={4}>
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Role List</h4>
              {/* <Link to={"/admin/add-roles"} className="btn btn-primary">
                + Add New
              </Link> */}
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <div id="holidayList" className="dataTables_wrapper no-footer">
                  {/* <div className="justify-content-between d-sm-flex">
                    <div className="dataTables_length"></div>
                    <div className="dataTables_filter">
                      <label>
                        Search :{" "}
                        <input
                          type="search"
                          className=""
                          placeholder=""
                          onChange={DataSearchRole}
                        />
                      </label>
                    </div>
                  </div> */}
                  <table
                    id="example4"
                    className="display dataTable no-footer w-100"
                  >
                    <thead>
                      <tr>
                        {roleThead.map((item, ind) => (
                          <th
                            key={ind}
                            onClick={() => {
                              SotingDataRole(item.sortingVale);
                              setRoleIconData((prevState) => ({
                                complete: !prevState.complete,
                                ind: ind,
                              }));
                            }}
                          >
                            {item.heading}
                            <span>
                              {ind !== roleIconData.ind && (
                                <i
                                  className="fa fa-sort ms-2 fs-12"
                                  style={{ opacity: "0.3" }}
                                />
                              )}
                              {ind === roleIconData.ind &&
                                (roleIconData.complete ? (
                                  <i
                                    className="fa fa-arrow-down ms-2 fs-12"
                                    style={{ opacity: "0.7" }}
                                  />
                                ) : (
                                  <i
                                    className="fa fa-arrow-up ms-2 fs-12"
                                    style={{ opacity: "0.7" }}
                                  />
                                ))}
                            </span>
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {roles?.map((data, ind) => (
                        <tr
                          key={ind}
                          className={
                            selectedRoleId === data.id ? "table-primary" : ""
                          }
                          style={{ cursor: "pointer" }}
                          onClick={() => setSelectedRoleId(data.id)}
                        >
                          <td>{data.name}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Col lg={8}>
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Permissions</h4>
              {/* <Link to={"/admin/add-permissions"} className="btn btn-primary">
                + Add New
              </Link> */}
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <div id="holidayList" className="dataTables_wrapper no-footer">
                  <div className="justify-content-between d-sm-flex">
                    {/* <div className="dataTables_length">
                      <label className="d-flex align-items-center">
                        Show
                        <Dropdown className="search-drop">
                          <Dropdown.Toggle as="div" className="search-drop-btn">
                            {sort}
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item onClick={() => setSortata("10")}>
                              10
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => setSortata("20")}>
                              20
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                        entries
                      </label>
                    </div> */}
                    {/* <div className="dataTables_filter">
                      <label>
                        Search :{" "}
                        <input
                          type="search"
                          className=""
                          placeholder=""
                          onChange={DataSearch}
                        />
                      </label>
                    </div> */}
                  </div>
                  <table
                    id="example4"
                    className="display dataTable no-footer w-100"
                  >
                    <thead>
                      <tr>
                        {theadData.map((item, ind) => (
                          <th
                            key={ind}
                            onClick={() => {
                              SotingData(item.sortingVale);
                              setPermissionIconData((prevState) => ({
                                complete: !prevState.complete,
                                ind: ind,
                              }));
                            }}
                          >
                            {item.heading}
                            <span>
                              {ind !== permissionIconData.ind && (
                                <i
                                  className="fa fa-sort ms-2 fs-12"
                                  style={{ opacity: "0.3" }}
                                />
                              )}
                              {ind === permissionIconData.ind &&
                                (permissionIconData.complete ? (
                                  <i
                                    className="fa fa-arrow-down ms-2 fs-12"
                                    style={{ opacity: "0.7" }}
                                  />
                                ) : (
                                  <i
                                    className="fa fa-arrow-up ms-2 fs-12"
                                    style={{ opacity: "0.7" }}
                                  />
                                ))}
                            </span>
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {permissionsLoading ? (
                        <tr>
                          <td colSpan={8} className="text-center py-4">
                            <div
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                            />
                            Loading permissions...
                          </td>
                        </tr>
                      ) : (
                        feeData.map((data, ind) => {
                          const allChecked = PERM_KEYS.every((k) => !!data[k]);
                          return (
                            <tr key={ind}>
                              <td>{data?.appModule?.name}</td>
                              {/* All */}
                              <td>
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id={`all-${data.id}`}
                                  checked={allChecked}
                                  onChange={(e) =>
                                    handleCheckbox(
                                      data.id,
                                      "all",
                                      e.target.checked,
                                    )
                                  }
                                />
                              </td>
                              {/* View */}
                              <td>
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id={`view-${data.id}`}
                                  checked={!!data.view}
                                  onChange={(e) =>
                                    handleCheckbox(
                                      data.id,
                                      "view",
                                      e.target.checked,
                                    )
                                  }
                                />
                              </td>
                              {/* Create */}
                              <td>
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id={`create-${data.id}`}
                                  checked={!!data.create}
                                  onChange={(e) =>
                                    handleCheckbox(
                                      data.id,
                                      "create",
                                      e.target.checked,
                                    )
                                  }
                                />
                              </td>
                              {/* Delete */}
                              <td>
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id={`delete-${data.id}`}
                                  checked={!!data.delete}
                                  onChange={(e) =>
                                    handleCheckbox(
                                      data.id,
                                      "delete",
                                      e.target.checked,
                                    )
                                  }
                                />
                              </td>
                              {/* Edit */}
                              <td>
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id={`edit-${data.id}`}
                                  checked={!!data.edit}
                                  onChange={(e) =>
                                    handleCheckbox(
                                      data.id,
                                      "edit",
                                      e.target.checked,
                                    )
                                  }
                                />
                              </td>
                              {/* Cancel */}
                              <td>
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id={`cancel-${data.id}`}
                                  checked={!!data.cancel}
                                  onChange={(e) =>
                                    handleCheckbox(
                                      data.id,
                                      "cancel",
                                      e.target.checked,
                                    )
                                  }
                                />
                              </td>
                              {/* Print */}
                              <td>
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id={`print-${data.id}`}
                                  checked={!!data.print}
                                  onChange={(e) =>
                                    handleCheckbox(
                                      data.id,
                                      "print",
                                      e.target.checked,
                                    )
                                  }
                                />
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default Permissions;
